import { registerCrudStore } from '@/libs/core/+state/register-crud-store';
import { ShiftModel, ShiftStationModel, ShiftScrapRecordModel } from '@/libs/Api';
import { ShiftsDataService } from '@/libs/shifts/shifts-data-service';
import { ShiftStationsDataService } from '@/libs/shifts/shift-stations-data-service';
import { ShiftScrapRecordsDataService } from '@/libs/shifts/shift-scrap-records-data-service';
import { BusinessModule } from '@/libs/core/models/business-module';

export const shiftsStore = registerCrudStore<ShiftModel, ShiftModel>(BusinessModule.Shift, new ShiftsDataService());
export const shiftStationsStore = registerCrudStore<ShiftStationModel, ShiftStationModel>(
    BusinessModule.ShiftStation,
    new ShiftStationsDataService()
);
export const shiftScrapRecordsStore = registerCrudStore<ShiftScrapRecordModel, ShiftScrapRecordModel>(
    BusinessModule.ShiftScrapRecord,
    new ShiftScrapRecordsDataService()
);
